var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_517_27416)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1041 8.89635L4.5339 15.4665M5.24296 10.6983L2.02479 9.9381C1.67073 9.85446 1.5462 9.4149 1.80269 9.15748L4.36198 6.59819C4.5339 6.42627 4.76716 6.32776 5.01156 6.3259L7.89704 6.30081M11.5315 2.99901C13.6791 4.46359 15.5368 6.32126 17.0014 8.46887M9.30121 14.7574L10.0614 17.9756C10.145 18.3297 10.5846 18.4542 10.842 18.1977L13.4013 15.6384C13.5732 15.4665 13.6717 15.2332 13.6736 14.9888L13.6987 12.1034M17.5525 6.95876L18.3033 3.34564C18.5078 2.36244 17.638 1.49261 16.6548 1.69706L13.0416 2.44793C11.9776 2.66911 11.0018 3.19602 10.2342 3.96455L7.26976 6.92809C6.13881 8.05905 5.4028 9.52549 5.17047 11.1081L5.16025 11.1759C5.01342 12.1861 5.35169 13.2055 6.07283 13.9276C6.79396 14.6487 7.81433 14.987 8.82448 14.8392L8.89232 14.829C10.4749 14.5976 11.9414 13.8607 13.0723 12.7297L16.0359 9.76618C16.8044 8.99857 17.3313 8.02281 17.5525 6.95876Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_517_27416"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "05ec3bd50b978df44de9b8085ee77bba.svg";
export { ForwardRef as ReactComponent };